export default {
  currentConversation: {},
};
